var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pulse-loader',{attrs:{"color":"#4B4F51","loading":_vm.loading,"size":_vm.size,"sizeUnit":"px"}})}
var staticRenderFns = []

export { render, staticRenderFns }